export const fonts = [
  // Professional Badge Fonts
  "Helvetica Neue",
  "Futura",
  "Proxima Nova",
  "Open Sans",
  "Avenir",
  "Muli",
  "Nunito",
  "Source Sans Pro",

  // Fancy/Decorative Fonts (New)
  "Great Vibes",
  "Cinzel",
  "Cormorant Garamond",
  "Pinyon Script",
  "Alex Brush",
  "Allura",
  "Petit Formal Script",
  "Tangerine",
  "Carattere",
  "Birthstone",
  "Playball",
  "Sacramento",
  "Berkshire Swash",
  "Mrs Saint Delafield",
  "Rouge Script",

  // Existing Fonts
  "Arial",
  "Courier New",
  "Georgia",
  "Times New Roman",
  "Verdana",
  "Montserrat",
  "Roboto",
  "Lobster",
  "Pacifico",
  "Raleway",
  "Indie Flower",
  "Monoton",
  "Playfair Display",
  "Permanent Marker",
  "Caveat",
  "Abril Fatface",
  "Oswald",
  "Dancing Script",
  "Bebas Neue",
  "Merriweather",
  "Ubuntu",
  "Josefin Sans",
  "Lato",
  "Quicksand",
  "Poppins",
  "Satisfy",
];
